import {
    authLogout,
    authLogoutPath,
    ConfigurationContext,
    getAuthParams,
    getLoginUrl,
    getSubscribeUrl,
    isArticle,
    IsHydrating,
    isServerEnvironment,
} from '@news-mono/web-common'
import React, { useContext } from 'react'
import { useDispatch } from 'react-redux'
import { useSectionMetaInfo } from '../../__helpers/use-section-meta'
import { BreachScreenContext } from '../breach/BreachContextProvider'

type AuthenticationProviderProps = {
    children: AuthenticationProviderChildren
    onEvent: (event: any) => void
}

interface SubscribeClickOverrides {
    offerCode?: string
    packagePath?: string
    callToAction?: string
}

export type OnSubscribeEventHandler = (
    overrides?: SubscribeClickOverrides,
) => void

type AuthenticationProviderChildren = (props: {
    onLoginClick(): void
    onLogoutClick(): void
    onSubscribeClick: OnSubscribeEventHandler
}) => React.ReactElement

export const AuthenticationProvider: React.FC<AuthenticationProviderProps> = ({
    children,
    onEvent,
}) => {
    const dispatch = useDispatch()
    const config = useContext(ConfigurationContext)
    const sectionMeta = useSectionMetaInfo()
    const isHydrating = React.useContext(IsHydrating)
    const breachScreenContext = React.useContext(BreachScreenContext)
    const context = breachScreenContext.context

    const hostname = sectionMeta.Hostname
        ? `https://${sectionMeta.Hostname}`
        : config.publicUrl
    const pageUrl =
        isServerEnvironment() || isHydrating
            ? hostname
            : `${hostname}${window.location.pathname}`

    const onLoginClick = () => {
        const loginUrl = getLoginUrl()
        window.location.href = loginUrl
    }

    const onLogoutClick = async () => {
        dispatch(
            authLogout({
                onEvent,
            }),
        )
        window.location.href = authLogoutPath
    }

    const onSubscribeClick: OnSubscribeEventHandler = (overrides) => {
        const auth = getAuthParams({ sectionMeta })
        const article =
            context?.publication && isArticle(context?.publication)
                ? context.publication
                : undefined

        const subscribeLink = getSubscribeUrl({
            config,
            auth,
            pageUrl,
            article,
            packagePath: overrides?.packagePath || context?.packagePath,
            source: sectionMeta.Hostname,
            productName: sectionMeta.Title,
            campaign: context?.breachCreativeName,
            callToAction: overrides?.callToAction,
            additionalParams: {
                utm_term: context?.breachDeal,
                utm_content: context?.publication?.id,
            },
            offerCode: overrides?.offerCode || context?.offerCode,
            returningUser: context?.returningUser,
            requiredAccessLevel: context?.requiredAccessLevel,
        })

        window.location.href = subscribeLink
    }

    return children({
        onLoginClick,
        onLogoutClick,
        onSubscribeClick,
    })
}
